import React from 'react';
import { Router, Route, Redirect, Switch } from "react-router-dom"
import { useClearCacheCtx } from 'react-clear-cache'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import Provider from 'pages/Header/Content/context/storeProvider'
import PrivateRoute from 'routers/privateRouter'
import BrowserHistory from 'routers/history'

import Home from 'pages/Home'
import { Beneficios } from 'pages/Beneficios'
import { BeneficiosExternal } from 'pages/Beneficios/index_external'
import Contacto from 'pages/Header/Content/pages/Contacto'
import ServicioCliente from 'pages/Header/Content/pages/ServicioCliente'
import test from 'pages/Test'

import ConsultarSaldo from 'pages/Credito/1-Consulta'
import SinCreditoAutorizado from 'pages/Home/SinCreditoAutorizado'
import VerificacionOTP from 'pages/Credito/VerificacionOTP'

import Movimientos from 'pages/Credito/6-Movimientos/movimientos'
import SolicitarEstadoCuenta from 'pages/Credito/5-EstadoCuenta/solicitarEstado'

import AgregarTarjetaBancaria from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria'
import {EditarTarjetaBancaria} from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria'
import PagarTarjeta from 'pages/Credito/PagarPlanes'
import { ElegirFormaPago } from 'pages/Credito/3-PagarTarjeta/ElegirFormaPago'
import { ElegirTarjeta } from 'pages/Credito/3-PagarTarjeta/ElegirTarjeta'
import PagarEnTienda from 'pages/Credito/3-PagarTarjeta/pagarEnTienda'
import PagoSpei from 'pages/Credito/3-PagarTarjeta/PagoSpei'
import ThankYouPage from 'pages/Credito/3-PagarTarjeta/pagar/thakyouPage'

import Login from 'pages/LoginRegistro/Login'
import Registro from 'pages/LoginRegistro/Registro'
import Authenticated from 'pages/LoginRegistro/Authenticated'
import RecuperarContrasenia from 'pages/LoginRegistro/RecoveryPassword'

import Error404 from 'pages/Error/Error404'




import SolicitarTarjeta from 'pages/Credito/10-SolicitarTarjeta';
import { AntesDeComenzar } from 'pages/NuevoCredito/AntesDeComenzar/landingAntesDeComenzar';
import { LineaTelmex } from 'pages/NuevoCredito/LineaTelmex/lineaTelmex';
import { ConLineaTelmex } from 'pages/NuevoCredito/ConLineaTelmex/conLineaTelmex';
import { PantallaError } from 'pages/NuevoCredito/MensajesErrores/pantallaError';
import VerificacionOTPNew from 'pages/NuevoCredito/VerificacionOTP';
import { PantallaComenzarIncode } from 'pages/NuevoCredito/Incode/comenzar';
import ComenzarIncodeIndex from 'pages/NuevoCredito/Incode/ComenzarIncode';
import { UltimosPasosCredito } from 'pages/NuevoCredito/Incode/UltimosPasosCredito';
import { DireccionIncode } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/DireccionIncode';
import { OcupacionIncode } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/OcupacionIncode';
import { IngresoMensuelIncode } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/IngresoMensual';
import { PreguntaSinTelmex } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/PreguntaSinTelmex';
import { CreacionDeNip } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/CreacionDeNip';
import { ComprobarNip } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/ComprobarNip';
import { RedirigirMovil } from 'pages/NuevoCredito/Incode/RedirigirMovil/redirigirMovil';
import { ProcesoTreminadoDesktop } from 'pages/NuevoCredito/Incode/ProcesoTerminadoDesktop/ProcesoTreminadoDesktop';
import SolicitudExitosa from 'pages/Credito/5-EstadoCuenta/solicitudExitosa';
import SolicitarPermisos from 'pages/Credito/5-EstadoCuenta/solicitarPermisos'

import RedirectApps from 'pages/RedirectApps'


BrowserHistory.listen(location => {
  //console.log('Set page to', location.pathname);
  // eslint-disable-next-line no-undef
  //ineum('page', location.pathname);
  // Note that the above can result in many useless pages when you are making use of path parameters.
  // In these cases you will have to define the page via different means, e.g. by creating a custom
  // Route component which accepts a 'pageName' property.
});

function App() {
  const { isLatestVersion, emptyCacheStorage } = useClearCacheCtx();

  return (
    <Provider>

      <Router history={BrowserHistory}>
        <Switch>

          <Route path={`${BASE_PATH}${SUB_DIRECTORY}home`} exact component={Home} />
          <Route exact path={`${BASE_PATH}`} ><Redirect to={`${BASE_PATH}${SUB_DIRECTORY}home`} /></Route>
          <Route exact path={`${BASE_PATH}${SUB_DIRECTORY}`} ><Redirect to={`${BASE_PATH}${SUB_DIRECTORY}home`} /></Route>
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}beneficios`} exact component={Beneficios} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}beneficios_external`} exact component={BeneficiosExternal} />
          <Route path="/contacto" component={Contacto} />
          <Route path="/servicio-cliente" component={ServicioCliente} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}test-ua/`} component={test} />


          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`} exact component={ConsultarSaldo} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}home/sin-credito`} component={SinCreditoAutorizado} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}home/autorizar`} component={VerificacionOTP} />


          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}movimientos/movimientos-tarjeta`} exact component={Movimientos} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}estado-cuenta/solicitar-estado-cuenta`} exact component={SolicitarEstadoCuenta} />


          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar/agregar-tarjeta-bancaria`} exact component={AgregarTarjetaBancaria} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar/editar-tarjeta-bancaria/:id?`} exact component={EditarTarjetaBancaria} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-tarjeta`} exact component={PagarTarjeta} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-forma-pago`} exact component={ElegirFormaPago} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-tarjeta`} exact component={ElegirTarjeta} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-en-tienda`} exact component={PagarEnTienda} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar/thankYouPage-spei`} exact component={PagoSpei} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar/thankYouPage`} exact component={ThankYouPage} />


          <Route path={`${BASE_PATH}${SUB_DIRECTORY}login`} component={Login} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}registro`} exact component={Registro} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}authenticated`} component={Authenticated} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}recuperar-contrasena/`} component={RecuperarContrasenia} />




          {/*NUEVO CREDITO*/}
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/autorizar`} exact component={VerificacionOTP}/>
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/formulario`} exact component={SolicitarTarjeta}/>
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}validacion-antes/:id`} component={AntesDeComenzar} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}linea-telmex`} component={LineaTelmex} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}con-linea-telmex`} component={ConLineaTelmex} />

          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}verificar-identidad`} exact component={VerificacionOTPNew}/>
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}comenzar-incocode-pantalla`} component={PantallaComenzarIncode} />
          {/* Redirect to Apps */}
          {/*<PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}redirect`} component={RedirectApps} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}comenzar-solicitud`} component={ComenzarIncodeIndex} />*/}
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}comenzar-solicitud`} component={RedirectApps} />
          
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito`} component={ComenzarIncodeIndex} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}redirigir-movil`} component={RedirigirMovil} />

          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos`} component={DireccionIncode} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-ocupacion`} component={OcupacionIncode} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-ingreso`} component={IngresoMensuelIncode} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-sin-telefono-telmex`} component={PreguntaSinTelmex} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-creacion-nip`} component={CreacionDeNip} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-comprobar-nip`} component={ComprobarNip} />

          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}proceso-terminado-incode`} component={ProcesoTreminadoDesktop} />
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}error-credito/:error`} component={PantallaError} />



          {/* error */}
          <Route path={`${BASE_PATH}:anything*`} component={Error404} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
